import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "bg-image-focusable"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "small text-muted"
}
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = {
  key: 1,
  class: "my-3 small"
}
const _hoisted_9 = { class: "small text-muted" }
const _hoisted_10 = {
  key: 0,
  class: "author icon icon-me-2 icon-start icon-user icon-secondary"
}
const _hoisted_11 = ["title"]


  import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import 'swiper/css';
  import 'swiper/css/navigation';
  import 'swiper/css/pagination';
  import 'swiper/css/scrollbar';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselBox',
  props: {
    login: { type: Boolean }
  },
  setup(__props) {

  const props = __props

  const swiperBreakpoints = (param: string) => { // Swiper の Vue コンポーネントは :breakpoints が正しく動作しないため自作する
    if (window.matchMedia( "(min-width: 992px)" ).matches) { // lg, xl, xxl
      if (param === 'slides-per-view') {
        return 3; // number
      }
      if (param === 'space-between') {
        return 20; // number
      }
    } else { // xs, sm, md
      if (param === 'slides-per-view') {
        return 1; // number
      }
      if (param === 'space-between') {
        return 0; // number
      }
    }
  }

  const swiperJSON = window.webtanSwiperJSON;


return (_ctx: any,_cache: any) => {
  return (_unref(swiperJSON).length && !__props.login)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Swiper), {
          modules: [_unref(Navigation), _unref(Pagination), _unref(Scrollbar), _unref(A11y)],
          "slides-per-view": swiperBreakpoints('slides-per-view'),
          "space-between": swiperBreakpoints('space-between'),
          navigation: "",
          loop: true,
          "centered-slides": true,
          pagination: { clickable: true }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(swiperJSON), (slide, i) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: i }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    class: "h-100 card text-decoration-none text-dark",
                    href: slide.url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, [
                    (slide.image)
                      ? (_openBlock(), _createElementBlock("figure", _hoisted_3, [
                          _createElementVNode("img", {
                            src: slide.image,
                            class: "card-img-top",
                            alt: ""
                          }, null, 8, _hoisted_4)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, [
                      (slide.subtitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(slide.subtitle), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(slide.title), 1),
                      (slide.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(slide.description), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_9, [
                        (slide.author)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(slide.author), 1))
                          : _createCommentVNode("", true),
                        (slide.published)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "ms-3 datetime created icon icon-me-2 icon-start icon-clock icon-secondary",
                              title: slide.published
                            }, _toDisplayString(slide.published), 9, _hoisted_11))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 8, _hoisted_2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules", "slides-per-view", "space-between"])
      ]))
    : _createCommentVNode("", true)
}
}

})